export default __webpack_public_path__ + "static/media/capture.11346432.png";